import Echarts from 'echarts'

// 在这里添加颜色变量 
const $primary = '#00bcff'
const $greyText = '#999'
const $white = '#ffffff'

const drawPieGraph = (el, data) => {
  const scale = 1
  const Chart = Echarts.init(el)
  const color = ['#FF6262','#FEBB66', '#00C6AE', '#4DDF97', '#9B99FB']

  const arr = []
  for (let [i, len] = [0, data.length]; i < len; i += 1) {
    arr.push(data[i].name)
  }

  Chart.setOption({
    color,
    tooltip: {
      show: true,
    //   formatter: '{b}（{c}）',
        formatter: '{b}',
        textStyle: {
            color: $white,
            fontSize: 14 * scale,
            lineHeight: 20
        }
    },
    legend: {
      orient: 'vertical',
      x: '65%',
      y: 'center',
      data: arr,
      width: 200
    },
    series: [
      {
        name: '年龄分布',
        type: 'pie',
        cursor: 'pointer',
        radius: ['55%', '80%'],
        center: ['35%', '50%'],
        legendHoverLink: true,
        hoverOffset: 5,
        label: {
          show: true,
          position: 'center',
          formatter: '{a}',
          textStyle: {
            color: '#778899',
            fontSize: 14 * scale,
            lineHeight: 20
          }
        },
        startAngle: 90,
        itemStyle: {
          borderWidth: 4,
          borderColor: '#FFFFFFFF'
        },
        emphasis: {
          itemStyle: {
            borderWidth: 4,
            borderColor: '#FFFFFFFF'
          }
        },
        labelLine: {
          normal: {
            show: false
          }
        },
        data
      },
      // 这里只是为了绘制边框
      {
        color: '#00C6AE',
        name: '绘制边框',
        type: 'pie',
        hoverAnimation: false,
        radius: ['89%', '90%'],
        center: ['35%', '50%'],
        data: [100],
        tooltip: {
          show: false
        },
        label: {
          show: false
        },
        labelLine: {
          show: false
        }
      }
    ]
  })
}

const drawPieGraph2 = (el, data) => {
  const scale = 1
  const Chart = Echarts.init(el)
  const color = [
    '#FF6262',
    '#FEBB66',
    '#FFDA5B',
    '#4DDF97',
    '#00C6AE',
    '#00BCFF',
    '#2699FB',
    '#8E79FB',
    '#9B99FB'
  ]

  const arr = []
  for (let [i, len] = [0, data.length]; i < len; i += 1) {
    arr.push(data[i].name)
  }

  Chart.setOption({
    color,
    tooltip: {
      show: true,
      formatter: '{b}：{c}',
      padding: [0, 10],
      textStyle: {
        color: $white,
        fontSize: 14 * scale,
        lineHeight: 20
      }
    },
    legend: {
      orient: 'horizontal',
      x: '64%',
      y: 'center',
      data: arr,
      width: 200,
      textStyle: {
        padding: [5, 10, 5, 10]
      }
    },
    series: [
      {
        name: '类型分布',
        type: 'pie',
        cursor: 'pointer',
        radius: ['60%', '80%'],
        center: ['35%', '50%'],
        legendHoverLink: true,
        hoverOffset: 5,
        label: {
          show: true,
          position: 'center',
          formatter: '{a}',
          textStyle: {
            color: '#778899',
            fontSize: 14 * scale,
            lineHeight: 20
          }
        },
        startAngle: 90,
        itemStyle: {
          borderWidth: 0
        },
        emphasis: {
          itemStyle: {
            borderWidth: 0
          }
        },
        labelLine: {
          normal: {
            show: false
          }
        },
        data
      },
      // 这里只是为了绘制边框
      {
        color: '#00C6AE',
        name: '绘制边框',
        type: 'pie',
        hoverAnimation: false,
        radius: ['89%', '90%'],
        center: ['35%', '50%'],
        data: [100],
        tooltip: {
          show: false
        },
        label: {
          show: false
        },
        labelLine: {
          show: false
        }
      }
    ]
  })
}

const drawBarGraph = (el, data) => {
//   console.log('查看参数----------'+el, data)
//   data.value[0] = [12,181,56,222,11]
//   data.value[1] = [112,11,356,22,111]
  const scale = 1
  const Chart = Echarts.init(el)
  const color = ['#FF7D97','#6FD6FF']

  Chart.setOption({
    color,
    legend: {
      x: 'right',
      data: [ '女','男']
    },
    grid: {
      left: '20px',
      right: '20px',
      top: '30px',
      bottom: '0',
      containLabel: true
    },
    xAxis: {
      type: 'value',
      max:500,
      axisLine: {
        show: true,
        lineStyle: {
          color: '#ccc'
        }
      },
      axisTick: {
        show: false
      },
      axisLabel: {
        color: $greyText,
        fontSize: 12 * scale
      }
    },
    yAxis: {
      type: 'category',
      axisLine: {
        show: true,
        lineStyle: {
          color: '#ccc'
        }
      },
      axisTick: {
        show: false
      },
      axisLabel: {
        width: 100
      },
      data: data.hours
    },
    series: [
      
      {
        name: '女',
        type: 'bar',
        stack: '总量',
        label: {
          normal: {
            show: true,
            position: 'insideRight'
          }
        },
        barCategoryGap: '25%',
        data: (data.value[0]).reverse()
      },
      {
        name: '男',
        type: 'bar',
        stack: '总量',
        label: {
          normal: {
            show: true,
            position: 'insideRight'
          }
        },
        barCategoryGap: '25%',
        data: (data.value[1]).reverse()
      }
    ]
  })
}

const drawPolylineGraph = (el, data) => {
  const scale = 1
  const Chart = Echarts.init(el)

  Chart.setOption({
    color: $primary,
    grid: {
      top: '20px',
      bottom: '0',
      left: '0',
      right: '0',
      containLabel: true
    },
    tooltip: {
      show: true,
      formatter: '{c}',
      padding: [0, 10],
      backgroundColor: $primary,
      textStyle: {
        color: $white,
        fontSize: 14 * scale,
        lineHeight: 20
      }
    },
    xAxis: {
      type: 'category',
      data: data.date,
      axisLine: {
        show: false
      },
      axisTick: {
        show: false
      },
      axisLabel: {
        color: $greyText,
        fontSize: 12 * scale
      }
    },
    yAxis: {
      type: 'value',
      minInterval:1,
      axisLine: {
        show: false
      },
      axisTick: {
        show: false
      },
      axisLabel: {
        color: $greyText,
        fontSize: 12 * scale
      }
    },
    series: [
      {
        data: data.values,
        type: 'line',
        itemStyle: {
          color: $primary
        }
      }
    ]
  })
}

export default {
  drawPieGraph,
  drawPieGraph2,
  drawBarGraph,
  drawPolylineGraph
}
